import React from 'react';
import { ConfigProvider, Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import styles from './AuthLayout.module.pcss';
import { useMediaQuery } from 'react-responsive';
import classNames from 'classnames';
import { Updater, useImmer } from 'use-immer';
import { MultitenantUser } from '@/service/Api/types';

const { Content } = Layout;

export type AuthLayoutOutletContext = {
  isMobile: boolean;
  authContextState: AuthLayoutState;
  updateAuthContextState: Updater<AuthLayoutState>;
};

type AuthLayoutState = {
  signInEmail: string;
  multitenantCredentials?: MultitenantUser;
};

export const AuthLayout: React.FC = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 900px)' });
  const [authContextState, updateAuthContextState] = useImmer<AuthLayoutState>({ signInEmail: '' });

  return (
    <ConfigProvider
      theme={{
        hashed: false,
        token: {
          colorPrimary: '#0FA06F',
          fontFamily: 'Inter',
        },
      }}
    >
      <Layout style={{ minHeight: '100%' }}>
        <Content className={styles.authContent}>
          <div
            className={classNames(styles.outlet, {
              [styles.mobile]: isMobile,
            })}
          >
            <Outlet context={{ isMobile, authContextState, updateAuthContextState }} />
          </div>
        </Content>
      </Layout>
    </ConfigProvider>
  );
};

export default AuthLayout;
